import { render } from "./TsorQuestions.vue?vue&type=template&id=1c20255c"
import script from "./TsorQuestions.vue?vue&type=script&lang=js"
export * from "./TsorQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__